// extracted by mini-css-extract-plugin
module.exports = {"SoundBar":"AudioAnalyser-module__SoundBar___NQG4O","soundBar":"AudioAnalyser-module__SoundBar___NQG4O"};